import { fetchAction, fetchActionPost, fetchPostApi } from "../../../helpers/fetch";
import { serialize } from "../../../helpers/serialize";


export const getOrders = () => fetchAction('/api/orders', [
    'GET_ORDERS_REQUEST',
    'GET_ORDERS_SUCCESS',
    'GET_ORDERS_FAILURE'
])

export const createOrderForFreeCreationOnly = (creationId) => fetchPostApi("/api/orders", { creation_id: creationId });

export const getOrderById = (order_id) => fetchAction(`/api/orders/${order_id}`, [
    'GET_ORDER_REQUEST',
    'GET_ORDER_SUCCESS',
    'GET_ORDER_FAILURE'
])

export const updateOrder = (order_status, order_id, carrier, tracking) => fetchActionPost('/api/orders/status', { order_status, order_id, carrier, tracking }, [
    'UPDATE_ORDER_REQUEST',
    'UPDATE_ORDER_SUCCESS',
    'UPDATE_ORDER_FAILURE'
])

export const fetchAllShipmentsByUser = (offset, limit, filter = {}) => {
    const query = serialize({ ...filter, offset, limit });
    const url = query ? `/api/orders/shipments?${query}` : '/api/orders/shipments';
    return fetchAction(url, [
        'FETCH_ALL_SHIPMENTS_REQUEST',
        'FETCH_ALL_SHIPMENTS_SUCCESS',
        'FETCH_ALL_SHIPMENTS_FAILURE'
    ]);
}

export const fetchAllOrderedCategories = () => {
    return fetchAction(`/api/orders/ordered-categories`, [
        'FETCH_CATEGORIES_REQUEST',
        'FETCH_CATEGORIES_SUCCESS',
        'FETCH_CATEGORIES_FAILURE'
    ]);
}

export const fetchOrderedCategoryCollection = (category) => {
    return fetchAction(`/api/orders/ordered-collection/${category}`, [
        'FETCH_CATEGORY_COLLECTION_REQUEST',
        'FETCH_CATEGORY_COLLECTION_SUCCESS',
        'FETCH_CATEGORY_COLLECTION_FAILURE'
    ]);
}

export const fetchRecentlyPurchased = (limit) => fetchAction(`/api/orders/recently-purchased?limit=${limit}`, [
    'FETCH_RECENTLY_PURCHASED_REQUEST',
    'FETCH_RECENTLY_PURCHASED_SUCCESS',
    'FETCH_RECENTLY_PURCHASED_FAILURE'
]); 

export const setActiveTab = (tab) => ({
    type: 'SET_ACTIVE_TAB',
    payload: tab
})

export const setCurrentOrder = (order) => ({
    type: 'SET_CURRENT_ORDER',
    payload: order
})

export const getFilteredOrders = (state) => {
    const orders = state.orders.orders || [];
    const activeTab = state.orders.activeTab;

    const filteredOrders = orders.filter(order => {
        if (activeTab === 'all') return true;

        return order.order_status === activeTab;
    });
    return filteredOrders;
}